/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ControlASN } from './ControlASN';
import {
    ControlASNFromJSON,
    ControlASNFromJSONTyped,
    ControlASNToJSON,
} from './ControlASN';
import type { ControlAbuse } from './ControlAbuse';
import {
    ControlAbuseFromJSON,
    ControlAbuseFromJSONTyped,
    ControlAbuseToJSON,
} from './ControlAbuse';
import type { ControlCompany } from './ControlCompany';
import {
    ControlCompanyFromJSON,
    ControlCompanyFromJSONTyped,
    ControlCompanyToJSON,
} from './ControlCompany';
import type { ControlDomains } from './ControlDomains';
import {
    ControlDomainsFromJSON,
    ControlDomainsFromJSONTyped,
    ControlDomainsToJSON,
} from './ControlDomains';
import type { ControlIPMetadataPrivacy } from './ControlIPMetadataPrivacy';
import {
    ControlIPMetadataPrivacyFromJSON,
    ControlIPMetadataPrivacyFromJSONTyped,
    ControlIPMetadataPrivacyToJSON,
} from './ControlIPMetadataPrivacy';

/**
 * 
 * @export
 * @interface ControlIPInfoMetadataImpl
 */
export interface ControlIPInfoMetadataImpl {
    /**
     * 
     * @type {ControlAbuse}
     * @memberof ControlIPInfoMetadataImpl
     */
    abuse: ControlAbuse;
    /**
     * 
     * @type {boolean}
     * @memberof ControlIPInfoMetadataImpl
     */
    adversarial: boolean;
    /**
     * 
     * @type {ControlASN}
     * @memberof ControlIPInfoMetadataImpl
     */
    asn: ControlASN;
    /**
     * 
     * @type {string}
     * @memberof ControlIPInfoMetadataImpl
     */
    city?: string;
    /**
     * 
     * @type {ControlCompany}
     * @memberof ControlIPInfoMetadataImpl
     */
    company: ControlCompany;
    /**
     * 
     * @type {string}
     * @memberof ControlIPInfoMetadataImpl
     */
    country?: string;
    /**
     * 
     * @type {ControlDomains}
     * @memberof ControlIPInfoMetadataImpl
     */
    domains: ControlDomains;
    /**
     * 
     * @type {string}
     * @memberof ControlIPInfoMetadataImpl
     */
    hostname?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlIPInfoMetadataImpl
     */
    ip?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ControlIPInfoMetadataImpl
     */
    isAnycast?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ControlIPInfoMetadataImpl
     */
    isMobile?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ControlIPInfoMetadataImpl
     */
    isSatellite?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ControlIPInfoMetadataImpl
     */
    loc?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ControlIPInfoMetadataImpl
     */
    ofac: boolean;
    /**
     * 
     * @type {string}
     * @memberof ControlIPInfoMetadataImpl
     */
    org?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlIPInfoMetadataImpl
     */
    postal?: string;
    /**
     * 
     * @type {ControlIPMetadataPrivacy}
     * @memberof ControlIPInfoMetadataImpl
     */
    privacy: ControlIPMetadataPrivacy;
    /**
     * 
     * @type {string}
     * @memberof ControlIPInfoMetadataImpl
     */
    region?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlIPInfoMetadataImpl
     */
    timezone?: string;
}

/**
 * Check if a given object implements the ControlIPInfoMetadataImpl interface.
 */
export function instanceOfControlIPInfoMetadataImpl(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "abuse" in value;
    isInstance = isInstance && "adversarial" in value;
    isInstance = isInstance && "asn" in value;
    isInstance = isInstance && "company" in value;
    isInstance = isInstance && "domains" in value;
    isInstance = isInstance && "ofac" in value;
    isInstance = isInstance && "privacy" in value;

    return isInstance;
}

export function ControlIPInfoMetadataImplFromJSON(json: any): ControlIPInfoMetadataImpl {
    return ControlIPInfoMetadataImplFromJSONTyped(json, false);
}

export function ControlIPInfoMetadataImplFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlIPInfoMetadataImpl {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'abuse': ControlAbuseFromJSON(json['abuse']),
        'adversarial': json['adversarial'],
        'asn': ControlASNFromJSON(json['asn']),
        'city': !exists(json, 'city') ? undefined : json['city'],
        'company': ControlCompanyFromJSON(json['company']),
        'country': !exists(json, 'country') ? undefined : json['country'],
        'domains': ControlDomainsFromJSON(json['domains']),
        'hostname': !exists(json, 'hostname') ? undefined : json['hostname'],
        'ip': !exists(json, 'ip') ? undefined : json['ip'],
        'isAnycast': !exists(json, 'isAnycast') ? undefined : json['isAnycast'],
        'isMobile': !exists(json, 'isMobile') ? undefined : json['isMobile'],
        'isSatellite': !exists(json, 'isSatellite') ? undefined : json['isSatellite'],
        'loc': !exists(json, 'loc') ? undefined : json['loc'],
        'ofac': json['ofac'],
        'org': !exists(json, 'org') ? undefined : json['org'],
        'postal': !exists(json, 'postal') ? undefined : json['postal'],
        'privacy': ControlIPMetadataPrivacyFromJSON(json['privacy']),
        'region': !exists(json, 'region') ? undefined : json['region'],
        'timezone': !exists(json, 'timezone') ? undefined : json['timezone'],
    };
}

export function ControlIPInfoMetadataImplToJSON(value?: ControlIPInfoMetadataImpl | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'abuse': ControlAbuseToJSON(value.abuse),
        'adversarial': value.adversarial,
        'asn': ControlASNToJSON(value.asn),
        'city': value.city,
        'company': ControlCompanyToJSON(value.company),
        'country': value.country,
        'domains': ControlDomainsToJSON(value.domains),
        'hostname': value.hostname,
        'ip': value.ip,
        'isAnycast': value.isAnycast,
        'isMobile': value.isMobile,
        'isSatellite': value.isSatellite,
        'loc': value.loc,
        'ofac': value.ofac,
        'org': value.org,
        'postal': value.postal,
        'privacy': ControlIPMetadataPrivacyToJSON(value.privacy),
        'region': value.region,
        'timezone': value.timezone,
    };
}

